export default __webpack_public_path__ + "static/media/header_e.993a9e14.png";